<template>
  <div>
    <v-btn
      style="width: 100%"
      variant="tonal"
      target="_blank"
      href="https://danillohss.github.io/drums-composition/"
    >
      Bateria Musical </v-btn
    ><br /><br />
    <v-btn
      variant="tonal"
      style="width: 100%"
      target="_blank"
      href="https://danillohss.github.io/relogio-analogico/"
    >
      Relógio analógico </v-btn
    ><br /><br />
    <v-btn
      style="width: 100%"
      variant="tonal"
      target="_blank"
      href="https://danillohss.github.io/JavaScript-Weather/"
    >
      Previsão do tempo </v-btn
    ><br /><br />
    <v-btn
      variant="tonal"
      style="width: 100%"
      target="_blank"
      href="https://danillohss.github.io/Jogo-da-velha/"
    >
      Jogo da velha </v-btn
    ><br /><br />
    <v-btn
      variant="tonal"
      style="width: 100%"
      target="_blank"
      href="https://danillohss.github.io/Screen-draw/"
    >
      Quadro de desenho </v-btn
    ><br /><br />
    <v-btn
      variant="tonal"
      style="width: 100%"
      target="_blank"
      href="https://danillohss.github.io/snack-project/"
    >
      Monte seu hambúrguer </v-btn
    ><br /><br />
    <v-btn
      style="width: 100%"
      variant="tonal"
      target="_blank"
      href="https://danillohss.github.io/PizzaStore/"
    >
      Pizzaria </v-btn
    ><br /><br />
    <v-btn
      variant="tonal"
      style="width: 100%"
      target="_blank"
      href="https://danillohss.github.io/urna-eletronica/"
    >
      Urna eletrônica </v-btn
    ><br /><br />
    <v-btn
      variant="tonal"
      style="width: 100%"
      target="_blank"
      href="https://catalogo-filmes-danillohss.netlify.app/"
    >
      Catálogo de filmes </v-btn
    ><br /><br />
    <v-btn
      variant="tonal"
      style="width: 100%"
      target="_blank"
      href="https://danillohss-tasks-app.netlify.app/"
    >
      Tarefas </v-btn
    ><br /><br />
    <v-btn
      variant="tonal"
      style="width: 100%"
      target="_blank"
      href="https://danillohss-vue-nutri.netlify.app/"
    >
      Vue nutri </v-btn
    ><br /><br />
    <v-btn
      variant="tonal"
      style="width: 100%"
      target="_blank"
      href="https://danillohss-quiz-game.netlify.app/"
    >
      Quiz Game </v-btn
    ><br /><br />
    <v-btn
      variant="tonal"
      style="width: 100%"
      target="_blank"
      href="https://danillohss-shopping.netlify.app"
    >
      Shopping </v-btn
    ><br /><br />
    <v-btn
      variant="tonal"
      style="width: 100%"
      target="_blank"
      href="https://danillohss-cronometro.netlify.app"
    >
      Cronometro </v-btn
    ><br /><br />
    <v-btn
      variant="tonal"
      style="width: 100%"
      target="_blank"
      href="https://danillohss-formulario.netlify.app"
    >
      Formulario com máscaras de input </v-btn
    ><br /><br />
    <v-btn
      variant="tonal"
      style="width: 100%"
      target="_blank"
      href="https://danillohss-vagas.netlify.app"
    >
      Vagas de emprego </v-btn
    ><br /><br />
  </div>
</template>

<script>
export default {
  name: "SLIDER",
};
</script>